import {
  Modal,
  Descriptions,
  Tag,
  Typography,
  Empty,
  Spin,
  Tooltip,
  Space,
} from "antd";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

// La etiqueta de visibilidad vive fuera del componente, asi que recibe `t` en
// vez de llamar al hook: un hook solo puede usarse dentro de un componente.
function vTag(v, t) {
  if (v === "global")
    return <Tag color="purple">{t("visibilidad.global")}</Tag>;
  if (v === "public")
    return <Tag color="blue">{t("visibilidad.institucion")}</Tag>;
  return <Tag>{t("visibilidad.privada")}</Tag>;
}

export function EvaluationDetailModal({
  isOpen,
  onClose,
  evaluation,
  loading = false,
}) {
  // Namespace propio de las evaluaciones + el comun, que ya trae "Estado" y
  // "Descripcion".
  const { t } = useTranslation(["evaluations", "common"]);

  return (
    <Modal
      title={t("detalle.titulo")}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={950}
      centered
      destroyOnHidden
    >
      {loading ? (
        <div style={{ minHeight: 240, display: "grid", placeItems: "center" }}>
          <Spin />
        </div>
      ) : !evaluation ? (
        <Empty description={t("detalle.sinSeleccion")} />
      ) : (
        <>
          <Descriptions bordered size="small" column={2}>
            <Descriptions.Item label={t("campos.titulo")} span={2}>
              {evaluation.title || "—"}
            </Descriptions.Item>

            <Descriptions.Item label={t("campos.tipo")}>
              {evaluation.type === "standardized" ? (
                <Tag color="purple">{t("tipos.estandar")}</Tag>
              ) : (
                <Tag color="blue">{t("tipos.personalizada")}</Tag>
              )}
            </Descriptions.Item>

            <Descriptions.Item label={t("campos.areaClinica")}>
              {/* Valor de BD: se muestra tal cual lo guardo el terapeuta. */}
              {evaluation.clinicalArea || "General"}
            </Descriptions.Item>

            <Descriptions.Item label={t("campos.subtipo")}>
              {evaluation.subtype || "—"}
            </Descriptions.Item>

            <Descriptions.Item label={t("common:fields.status")}>
              <Tag color={evaluation.active ? "green" : "default"}>
                {evaluation.active ? t("estado.activa") : t("estado.inactiva")}
              </Tag>
            </Descriptions.Item>

            {evaluation.type === "custom" ? (
              <Descriptions.Item label={t("campos.visibilidad")} span={2}>
                {vTag(evaluation.visibility, t)}
              </Descriptions.Item>
            ) : null}

            <Descriptions.Item label={t("common:fields.description")} span={2}>
              <Text type="secondary">{evaluation.description || "—"}</Text>
            </Descriptions.Item>
          </Descriptions>

          <div style={{ marginTop: 16 }}>
            {/*
              Contador con parentesis: "Preguntas (0)" en castellano pero
              "Question (0)" en frances, donde el cero va en singular.
            */}
            <Text strong>
              {t("detalle.preguntasTitulo", {
                count: evaluation.questions?.length || 0,
              })}
            </Text>

            {/* ✅ Sustitución de antd/List por un map() simple (sin warning) */}
            <div style={{ marginTop: 8, maxHeight: 360, overflow: "auto" }}>
              {(evaluation.questions || []).length === 0 ? (
                <Empty description={t("detalle.sinPreguntas")} />
              ) : (
                (evaluation.questions || []).map((q, idx) => {
                  const key = q?._id || q?.id || `${idx}`;
                  const text =
                    q?.text || q?.question || t("detalle.preguntaSinTexto");

                  return (
                    <div
                      key={key}
                      style={{
                        padding: "10px 0",
                        borderBottom: "1px solid #f0f0f0",
                      }}
                    >
                      <Space align="start" size={8} wrap>
                        {/*
                          El enunciado es contenido clinico y entra sin tocar;
                          lo que si es interfaz es como se numera.
                        */}
                        <Text>
                          {t("detalle.preguntaNumerada", {
                            numero: idx + 1,
                            enunciado: text,
                          })}
                        </Text>

                        {q?.reverse ? (
                          <Tooltip title={t("invertida.tooltipDetalle")}>
                            <Tag color="orange">{t("invertida.etiqueta")}</Tag>
                          </Tooltip>
                        ) : null}
                      </Space>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </>
      )}
    </Modal>
  );
}
